import { Card, CardContent } from '@/components/ui/card';
import type { Stats } from '@/types';
import { formatPercentage } from '@/utils/helpers';

interface StatsGridProps {
  stats: Stats;
}

export function StatsGrid({ stats }: StatsGridProps) {
  const statCards = [
    {
      title: 'Total Matches',
      value: stats.total_matches || 0,
      color: 'bg-blue-500',
    },
    {
      title: 'Verified',
      value: stats.verified_matches || 0,
      subtitle: formatPercentage((stats.verified_matches / stats.total_matches) || 0),
      color: 'bg-green-500',
    },
    {
      title: 'Unmatched FIPE',
      value: stats.unmatched_fipe || 0,
      color: 'bg-yellow-500',
    },
    {
      title: 'Unmatched PBEV',
      value: stats.unmatched_pbev || 0,
      color: 'bg-orange-500',
    },
    {
      title: 'Avg Confidence',
      value: formatPercentage(stats.avg_confidence || 0),
      color: 'bg-purple-500',
    },
    {
      title: 'Manual Matches',
      value: stats.manual_matches || 0,
      color: 'bg-pink-500',
    },
    {
      title: 'Manual Consumption',
      value: stats.manual_consumption_records || 0,
      color: 'bg-cyan-500',
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-7 gap-4 mb-6">
      {statCards.map((stat) => (
        <Card key={stat.title} className="border-l-4" style={{ borderLeftColor: stat.color.replace('bg-', '') }}>
          <CardContent className="p-4">
            <div className="text-sm font-medium text-muted-foreground mb-2">
              {stat.title}
            </div>
            <div className="text-2xl font-bold">{stat.value}</div>
            {stat.subtitle && (
              <div className="text-sm text-muted-foreground mt-1">
                {stat.subtitle}
              </div>
            )}
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
